module.exports = __webpack_public_path__ + "img/google-maps.dd95b180.svg";